<template>
    <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
        <!-- <div class="navbar-brand"> -->
            <nav class="breadcrumb is-medium is-centered has-bullet-separator" aria-label="breadcrumbs">
                <ul>
                    <li>
                        <router-link class="routerlink" to="/">
                            Home
                        </router-link>
                    </li>
                    <li>
                        <router-link class="routerlink" :to="{name: 'About'}">
                            About
                        </router-link>
                    </li>
                    <li>
                        <a href="https://github.com/Alex-Stefanou/Demonstration-Practice-Code" target="_blank">
                            Projects
                        </a>
                    </li>
                    <!-- <li>
                        <router-link class="routerlink" :to="{name: 'Gallery'}">
                            Gallery
                        </router-link>
                    </li> -->
                    <li>
                        <router-link class="routerlink" :to="{name: 'Games Home'}">
                            Games
                        </router-link>
                    </li>
                </ul>
            </nav>
        <!-- </div> -->
    </nav>
</template>

<script>
export default {
    name: 'Navbar',
    components: {
    }
}
</script>

<style scoped>
.breadcrumb {
    margin: auto;
}
</style>